import styled from 'styled-components';

import { InputLabel } from '@mui/material';

export const TruncatedInputLabel = styled(InputLabel)`
  display: flex;
  align-items: center;
  width: 100%;
  pointer-events: auto;

  .label-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  .required-asterisk {
    color: red;
    margin-left: 4px;
    flex-shrink: 0;
  }
`;
